import styled, { css } from 'styled-components'
import theme from 'theme_'

export const NetworkClientListClientLineItem = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0px 24px 0px 16px;
  gap: 12px;
  height: 48px;
  background: #ffffff;
  box-shadow: inset 0px -1px 0px rgba(0, 0, 0, 0.05);

  flex: none;
  order: 1;
  align-self: stretch;
  flex-grow: 0;
`

export const NetworkClientListHeaderTextBase = css`
  display: flex;
  flex-direction: column;
  flex: 1;
  width: 100%;
  white-space: nowrap;
  align-items: left;
  gap: ${theme.spacing.tiny};
  height: 40px;
  width: 100%;
`

export const NetworkClientListHeaderTextFrameName = styled.div`
  ${NetworkClientListHeaderTextBase};
  overflow-y: hidden; /* Hide horizontal scrollbar */
  overflow-x: hidden; /* Add vertical scrollbar */
  :hover {
    overflow-x: scroll;
  }
`

export const NetworkClientListHeaderTextFrameMac = styled.div`
  ${NetworkClientListHeaderTextBase};
  min-width: 130px;
`

export const NetworkClientListHeaderTextFrameIP = styled.div`
  ${NetworkClientListHeaderTextBase};
  max-width: 80px;
  @media ${theme.devices.mobile} {
    display: none;
  }
`

export const NetworkClientListHeaderTextFrameDevice = styled.div`
  ${NetworkClientListHeaderTextBase};
  overflow-y: hidden; /* Hide horizontal scrollbar */
  overflow-x: hidden; /* Add vertical scrollbar */
  :hover {
    overflow-x: scroll;
  }
  @media ${theme.devices.mobile} {
    display: none;
  }
`

export const NetworkClientListHeaderTextFrameProtocol = styled.div`
  ${NetworkClientListHeaderTextBase};
  max-width: 60px;

  @media ${theme.devices.tablet} {
    display: none;
  }

  @media ${theme.devices.mobile} {
    display: none;
  }

  @media ${theme.devices.mediumDesktop} {
    display: flex;
  }
`

export const NetworkClientListHeaderTextFrameBand = styled.div`
  ${NetworkClientListHeaderTextBase};
  max-width: 60px;

  @media ${theme.devices.tablet} {
    display: none;
  }

  @media ${theme.devices.mobile} {
    display: none;
  }

  @media ${theme.devices.mediumDesktop} {
    display: flex;
  }
`

export const NetworkClientListHeaderTextFrameSSID = styled.div`
  ${NetworkClientListHeaderTextBase};
  max-width: 90px;
  overflow-y: hidden; /* Hide horizontal scrollbar */
  overflow-x: hidden; /* Add vertical scrollbar */
  :hover {
    overflow-x: scroll;
  }

  @media ${theme.devices.tablet} {
    display: none;
  }

  @media ${theme.devices.mobile} {
    display: none;
  }

  @media ${theme.devices.mediumDesktop} {
    display: flex;
  }
`

export const NetworkClientListHeaderTextFrameBytes = styled.div`
  ${NetworkClientListHeaderTextBase};
  max-width: 80px;

  @media ${theme.devices.tablet} {
    display: none;
  }

  @media ${theme.devices.mobile} {
    display: none;
  }

  @media ${theme.devices.mediumDesktop} {
    display: flex;
  }
`
export const NetworkClientListHeaderTextFrameConnected = styled.div`
  ${NetworkClientListHeaderTextBase};
  max-width: 70px;

  @media ${theme.devices.tablet} {
    display: none;
  }

  @media ${theme.devices.mobile} {
    display: none;
  }

  @media ${theme.devices.mediumDesktop} {
    display: flex;
  }
`

export const NetworkClientListHeaderText = styled.span`
  /* Text */

  width: 42px;
  height: 24px;

  font-style: normal;
  font-weight: 350;
  font-size: 14px;
  line-height: 24px;
  /* identical to box height, or 171% */

  color: ${theme.colors.otterWarmBlack};

  flex: none;
  order: 0;
  flex-grow: 0;
`

export const NetworkClientListHeaderTextFrame = styled.div`
  flex-direction: row;
  align-items: center;
  padding: 0px;
  gap: 8px;
  height: 24px;

  flex: none;
  order: 0;
  flex-grow: 0;
  overflow: hidden;
`
